<template>
	<EventLayout :event="event" :subtitle="trans('events.payment_links.subtitle')">
		<Card :title="trans('enrollments.payments.debit')">
			<PaymentLinksComponent :event-id="event.id" :links="debitPaymentLinks" :type="PaymentLinkType.Debit"/>
		</Card>
		<Card :title="trans('enrollments.payments.credit')">
			<PaymentLinksComponent :event-id="event.id" :links="creditPaymentLinks" :type="PaymentLinkType.Credit"/>
		</Card>
	</EventLayout>
</template>
<script setup lang="ts">
import {trans} from 'laravel-vue-i18n'
import Card from '@/Components/UI/Cards/Card.vue'
import {defineProps, type Ref, ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import EventLayout from '@/Layouts/EventLayout.vue'
import {PaymentLinkType} from '@/Types/Enums/PaymentLinkType'
import {type PaymentLink} from '@/Types/Events/Payments/PaymentLink'
import PaymentLinksComponent from '@/Components/Events/Payments/PaymentLinks.vue'

const props = defineProps<{
	event:Event,
	debitPaymentLinks:Array<PaymentLink>,
	creditPaymentLinks:Array<PaymentLink>,
}>()

const event:Ref<Event> = ref(props.event)
</script>